import clsx from 'clsx'
import { ReactNode, forwardRef } from 'react'

/** A small bordered pill for a label; forwards its ref so it can be a `Tippy` tooltip anchor. */
const Chip = forwardRef<
  HTMLDivElement,
  {
    children?: ReactNode
    className?: string
    style?: any
  }
>(({ children, className, style }, ref) => {
  return (
    <div
      ref={ref}
      className={clsx(
        'text-sm px-2 py-1 border-1 border-gray-300 border-round  bg-gray-50',
        className
      )}
      style={style}
    >
      {children}
    </div>
  )
})

export default Chip
